require('./brokerMarketsView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { Link } = require('react-router-dom');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const moment = require('moment');

// @components
const { StocksBanner } = require('components/broker/stocksBanner/stocksBanner');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const OKLoadingErrorMessage = require('components/commons/OKLoadingErrorMessage/OKLoadingErrorMessage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKBoxSectionContent } = require('commonsComponents/OKBoxSectionContent');
const { OKBoxNewPreview } = require('commonsComponents/OKBoxNewPreview');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKLink } = require('commonsComponents/OKLink');
const { BrokerAccordionIndexes } = require('./brokerAccordionIndexes/brokerAccordionIndexes');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const OKModal = require('components/commons/OKModal/OKModal');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getFirstNWords } = require('utilities/stringHelper');
const { getMinLengthIndexes, getListNews } = require('utilities/brokerMarketsHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @actions
const brokerMarketsActions = require('actions/brokerMarkets');
const brokerTodaysMainStocksActions = require('actions/brokerTodaysMainStocks');

// @constants
const { PROC_BROKER__MARKETS_PG_NAME } = require('utilities/tagging');
const {
    FINANCES_NEWS,
    LAST_NEWS,
    MAX_LAST_NEWS,
    MAX_FINANCES_NEWS,
} = require('constants/brokerMarkets');
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');
const { MARKETS_AND_NEWS_FINANACES } = require('constants/flagBasedFeatures');

class BrokerMarketsView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showTickerModal: false
        };
    }

    componentDidMount() {
        const { immBrokerMarket, requestAllNews, getIndexes, immBrokerExchangeIndexes } = this.props;

        this.props.setPreoviousPage('/myprofile/broker/markets')

        if (immBrokerExchangeIndexes.get('indexes').size === 0)
            getIndexes();

        if (!getMinLengthIndexes(immBrokerMarket) && immBrokerMarket.get('indexesData').length !== 0)
            this.getIndexesData();

        if (immBrokerMarket.get('financesNews').length === 0 || immBrokerMarket.get('lastNews').length === 0)
            requestAllNews();

        const customData = {
            nombrePagina: 'broker/mercados',
        };
        window && window.utag && window.utag.view && window.utag.view(customData)
    }

    componentDidUpdate() {
        const { immBrokerMarket, immBrokerExchangeIndexes } = this.props;

        if (immBrokerExchangeIndexes.get('indexes').size > 0 && immBrokerMarket.get('indexesData').length === 0)
            this.getIndexesData();
    }

    getIndexesData = () => {
        const { immBrokerExchangeIndexes, originCountry, requestIndexesHistoricalDataMedysif } = this.props;
        const dateFormat = DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_TIMESERIES;
        requestIndexesHistoricalDataMedysif(immBrokerExchangeIndexes.get('indexes'), moment().subtract(1, 'year').format(dateFormat), moment().format(dateFormat))
    }

    buildGridNews = (type) => {
        const { immBrokerMarket, originCountry } = this.props;

        if (immBrokerMarket.get('lastNews') && immBrokerMarket.get('financesNews')) {
            const isLastNews = type === LAST_NEWS;
            const newsData = isLastNews ?  getListNews(immBrokerMarket.get('lastNews'), MAX_LAST_NEWS) : getListNews(immBrokerMarket.get('financesNews'), MAX_FINANCES_NEWS)
            const urlDetailNew = isLastNews ? 'last-news-detail' : 'finances-news-detail';
            const newsGridClassName = classnames('broker-markets-view__list-news', {
                'col-xs-6 -no-margin-bottom': !isLastNews
            })

            const lastNews = newsData.map((news, index) => {
                const newsDate = isLastNews ? news.newsDate : news.creationDate;
                const newsDateFormat = !!newsDate ? moment(newsDate).format(DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_WITH_DASHES_DATETIME) : '';
                const urlDetailNewValue = isLastNews ? news.urn : encodeURIComponent(news.title1)
                const newsLinkContent = `/myprofile/broker/markets/${urlDetailNew}/${urlDetailNewValue}`
                    return (
                        <div className={newsGridClassName} key={index.toString()}>
                            <OKBoxNewPreview
                                hasCover={!isLastNews}
                                coverImage={news.viewRef}
                                title={news.title}
                                description={news.title2 ? getFirstNWords(news.title2) : ''}
                                date={newsDateFormat}
                                linkContent={
                                    <Link
                                        onClick={() => {
                                            taggingEventHandled(PROC_BROKER__MARKETS_PG_NAME, type === 'LAST_NEWS' ? 'keepReadingLink' : 'keepReadingMarkets', undefined, index + 1)
                                        }}
                                        to={newsLinkContent}>
                                        <FormattedText value="brokerMarketNews-readMoreNews" />
                                    </Link>
                                }
                            />
                        </div>
                    )
            })

            return lastNews;
        }
    }

    buildLoadingErrorMessagesFinancesNews = (type) => {
        const { immBrokerMarket } = this.props;
        const loading = type === LAST_NEWS ? immBrokerMarket.get('fetchingLastNews') : immBrokerMarket.get('fetchingFinancesNews');
        const error = type === LAST_NEWS ? immBrokerMarket.get('errorLastNews') : immBrokerMarket.get('errorFinancesNews');

        return (
            <OKLoadingErrorMessage
                isLoading={loading}
                isError={error}
                primaryTextError="error"
                iconTypeError="noitems-banking"
            >
                {this.buildGridNews(type)}
            </OKLoadingErrorMessage>
        );
    }

    builTickerModal() {
        const { immBrokerExchangeIndexes } = this.props;
        const { showTickerModal } = this.state;
        const indexes = immBrokerExchangeIndexes.get('indexes')
        if (!showTickerModal) {
            this.setState({
                showTickerModal: true
            })
        }
        if (showTickerModal) {
            const modalContent = (
                <React.Fragment>
                    <div>
                        <FormattedText value="broker-tickerModalSubtitle"></FormattedText>
                    </div>
                    <div>
                        <ul className="broker-markets-view__modal-list">
                            {indexes.map((index, i) => {
                                if (i <= 5) {
                                    const tickerItemtText = `broker-tickerModalItem${i+1}`;
                                    return (
                                        <li key={index} className="broker-general-view__modal-list-item" >
                                            <FormattedText value={tickerItemtText}></FormattedText>
                                        </li>
                                    );
                                }
                                else return null;
                            })}
                        </ul>
                    </div>
                    <div>
                        <FormattedText value="broker-tickerModalSource"></FormattedText>
                    </div>
                </React.Fragment>
            );

            return (
                <OKModal
                    content={modalContent}
                    footerType="navigation"
                    isOpen={true}
                    onCloseCallback={() => this.setState({ showTickerModal: false })}
                    onPrimaryButtonClick={() => this.setState({ showTickerModal: false })}
                    primaryButtonText="raNonresidentialModal-button"
                    title="broker-tickerModalTitle"
                />
            );
        }
    }

    showModal() {
        if(!this.state.showTickerModal){
            this.setState({ showTickerModal:true })
        }
    }

    render() {
        const { flagBasedFeatures, immBrokerExchangeIndexes, immBrokerMarket } = this.props;
        const marketAdvise = classnames('broker-markets-view__advise', {
            'broker-markets-view__advise--after-hiding-finance-section': !flagBasedFeatures.get(MARKETS_AND_NEWS_FINANACES) && __CONTACT_CENTER__
        });
        const disclaimerText = formatText('broker-disclaimerText');
        const tickerModal = this.state.showTickerModal ? this.builTickerModal() : null;
        const filterIndexes = ['PSI20', 'FTSE100'];
        return (
            <div className="broker-markets-view">
                {tickerModal}
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="broker" customClass="col-xs-12">
                            <OKHeaderLanding
                                title={<FormattedText value="broker-marketsTitle" />}
                                inputClassName="ok-header-landing--broker">
                            </OKHeaderLanding>
                        </OKCover>
                    </div>
                    <div className="row broker-markets-view__banner-container">
                        <StocksBanner />
                        <div className="row broker-markets-view__disclaimer">
                            {disclaimerText}
                            <OKLink
                                extraClass="broker-markets-view__disclaimer"
                                onClick={() => this.builTickerModal()}
                            >
                                {formatText('broker-moreInfo')}
                            </OKLink>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-8">
                                    <OKBoxSectionContent
                                        title={<FormattedText value="brokerMarketNews-lastNewsTitle" />}
                                        subTitle={<FormattedText value="brokerMarketNews-lastNewsSubTitle" />}
                                        footerContentRight={
                                            <Link onClick={() => taggingEventHandled(PROC_BROKER__MARKETS_PG_NAME, 'seeMoreNewsLink')}
                                                className="broker-markets-view__link-footer-section" to="/myprofile/broker/markets/last-news">
                                                <FormattedText value="brokerMarketNews-moreNews" />
                                            </Link>
                                        }
                                        content={this.buildLoadingErrorMessagesFinancesNews(LAST_NEWS)}
                                    />
                                    <FeatureTogglingRender notAllowedProductKey={MARKETS_AND_NEWS_FINANACES} >
                                        <div className="broker-markets-view__news-image-container">
                                            <OKBoxSectionContent
                                                title={<FormattedText value="brokerMarketNews-financesNewsTitle" />}
                                                subTitle={<FormattedText value="brokerMarketNews-financesNewsSubTitle" />}
                                                footerContentRight={
                                                    <Link onClick={() => taggingEventHandled(PROC_BROKER__MARKETS_PG_NAME, 'seeMoreMarketsNews')} className="broker-markets-view__link-footer-section"  to="/myprofile/broker/markets/finances-news">
                                                        <FormattedText value="brokerMarketNews-moreNews" />
                                                    </Link>
                                                }
                                                content={
                                                    <div className="row">
                                                        {this.buildLoadingErrorMessagesFinancesNews(FINANCES_NEWS)}
                                                    </div>
                                                }
                                            />
                                        </div>
                                    </FeatureTogglingRender>
                                </div>
                                <div className="col-xs-4">
                                    <OKBoxSectionContent
                                        title={
                                            <div className="broker-markets-view__header-title-indexes">
                                                <FormattedText value="brokerMarketNews-indexesTitle" />
                                                <i
                                                    className="icon icon-tooltip broker-markets-view__header-title-indexes__icon-tooltip"
                                                    onClick={() => {
                                                        taggingEventHandled(PROC_BROKER__MARKETS_PG_NAME, 'indexTooltip')
                                                        this.showModal()
                                                    }}
                                                />
                                            </div>
                                        }
                                        footerContentRight={
                                            <Link onClick={() => taggingEventHandled(PROC_BROKER__MARKETS_PG_NAME, 'indexSeeMore')} to="/myprofile/broker/markets/indexes" className="broker-markets-view__link-white-footer-section" >
                                                <FormattedText value="brokerMarketNews-moreDetails" />
                                            </Link>
                                        }
                                        darkStyle
                                        content={
                                            <BrokerAccordionIndexes
                                                immBrokerExchangeIndexes={immBrokerExchangeIndexes}
                                                immBrokerMarket={immBrokerMarket}
                                                filterIndexes={filterIndexes}
                                            />
                                        }
                                    />
                                    <div className="broker-markets-view__commerdial-ads">
                                        <CommercialAds path="broker/markets" type="banner-a" />
                                    </div>
                                </div>
                            </div>
                            <div className={marketAdvise}>
                                <FormattedText value="brokerMarketNews-morningstarAdvise" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid grid-view__cross-selling">
                    <div className="row">
                        <CommercialAds path="broker/markets" type="cross-selling" size="medium" />
                    </div>
                </div>
            </div>
        );
    }
}

BrokerMarketsView.propTypes = {
    flagBasedFeatures: PropTypes.object,
    immBrokerMarket: PropTypes.object,
    requestAllNews: PropTypes.func,
    getIndexes: PropTypes.func,
    requestIndexesData: PropTypes.func,
    requestIndexesHistoricalDataMedysif: PropTypes.func,
    immBrokerExchangeIndexes: PropTypes.object,
    originCountry: PropTypes.object,
    setPreoviousPage: PropTypes.func
};

module.exports.constructor = BrokerMarketsView;
module.exports.BrokerMarketsView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immBrokerMarket: state.brokerMarkets,
        immBrokerExchangeIndexes: state.brokerExchangeIndexes,
        originCountry: state.profile.get('originCountry')
    }), {
        requestAllNews: brokerMarketsActions.requestAllNews,
        requestIndexesData: brokerMarketsActions.requestIndexesData,
        requestIndexesHistoricalDataMedysif: brokerMarketsActions.requestIndexesHistoricalDataMedysif,
        getIndexes: brokerTodaysMainStocksActions.getIndexes,
        setPreoviousPage: brokerTodaysMainStocksActions.setPreoviousPage,
})(BrokerMarketsView);
